










































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
@Component({
  name: 'bpc-session-calendar-item',
  components: {},
})
export default class SessionCalendarItem extends Vue {
  // PROPS
  @Prop({ type: Object }) readonly session: any;
  @Prop({ type: Object }) readonly mountPopoverModel: Record<number, boolean>;
  @Prop({ type: String }) readonly timeText: string;

  // DATA
  canBeShown = false;
  // LIFECYCLE

  mounted() {
    this.canBeShown = true;
  }
  // updated(){}
  // destroyed(){}

  // COMPUTED
  // METHODS

  // WATCHERS
}
